import { VApp } from 'vuetify/lib/components/VApp';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VOverlay } from 'vuetify/lib/components/VOverlay';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    VApp,
    { staticClass: "custom-webmap" },
    [
      _c(
        VRow,
        { staticClass: "fill-height", attrs: { "no-gutters": "" } },
        [
          _c(
            VCol,
            { staticClass: "custom-webmap__aside" },
            [_c("map-sidebar")],
            1
          ),
          _vm._v(" "),
          _c(
            VCol,
            { staticClass: "custom-webmap__map" },
            [
              _vm.mapOptions
                ? _c(
                    "vue-ngw-map",
                    {
                      staticClass: "ngw-map",
                      attrs: {
                        mapOptions: _vm.mapOptions,
                        connector: _vm.connector,
                      },
                      on: { load: _vm.onNgwMapLoad },
                    },
                    [
                      _c("vue-ngw-control", { attrs: { kind: "ZOOM" } }),
                      _vm._v(" "),
                      _c("MeasureControl", { attrs: { ngwMap: _vm.ngwMap } }),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        VOverlay,
        { attrs: { value: _vm.isLoading, opacity: 1 } },
        [
          _c(VProgressCircular, {
            attrs: { indeterminate: "", size: "64" },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }